export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_FAIL = "GET_USERS_FAIL"

/**
 * Delete USER
 */
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"

/**
 * Add USER
 */
export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_FAIL = "ADD_USER_FAIL"

/**
 * Get USER DETAILS
 */
export const GET_USER_DETAIL = "GET_USER_DETAIL"
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS"
export const GET_USER_DETAIL_FAIL = "GET_USER_DETAIL_FAIL"

/**
 * Edit USER
 */
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"

/**
 * Add/Edit Photo
 */

export const UPDATE_USER_PHOTO = "UPDATE_PHOTO"
export const UPDATE_USER_PHOTO_SUCCESS = "UPDATE_PHOTO_SUCCESS"
export const UPDATE_USER_PHOTO_FAIL = "UPDATE_PHOTO_FAIL"

/**
 * Reset USER
 */
export const RESET_USER = "RESET_USER"
export const RESET_USER_SUCCESS = "RESET_USER_SUCCESS"

/*Get PAYRATE */
export const GET_PAYRATES = "GET_PAYRATES"
export const GET_PAYRATES_SUCCESS = "GET_PAYRATES_SUCCESS"
export const GET_PAYRATES_FAIL = "GET_PAYRATES_FAIL"

/**
 * Delete PAYRATE
 */
export const DELETE_PAYRATE = "DELETE_PAYRATE"
export const DELETE_PAYRATE_SUCCESS = "DELETE_PAYRATE_SUCCESS"
export const DELETE_PAYRATE_FAIL = "DELETE_PAYRATE_FAIL"

/**
 * Add PAYRATE
 */
export const ADD_NEW_PAYRATE = "ADD_NEW_PAYRATE"
export const ADD_PAYRATE_SUCCESS = "ADD_PAYRATE_SUCCESS"
export const ADD_PAYRATE_FAIL = "ADD_PAYRATE_FAIL"

/**
 * Get PAYRATE DETAILS
 */
export const GET_PAYRATE_DETAIL = "GET_PAYRATE_DETAIL"
export const GET_PAYRATE_DETAIL_SUCCESS = "GET_PAYRATE_DETAIL_SUCCESS"
export const GET_PAYRATE_DETAIL_FAIL = "GET_PAYRATE_DETAIL_FAIL"

/**
 * Edit PAYRATE
 */
export const UPDATE_PAYRATE = "UPDATE_PAYRATE"
export const UPDATE_PAYRATE_SUCCESS = "UPDATE_PAYRATE_SUCCESS"
export const UPDATE_PAYRATE_FAIL = "UPDATE_PAYRATE_FAIL"

/**
 * Reset PAYRATE
 */
export const RESET_PAYRATE = "RESET_PAYRATE"
export const RESET_PAYRATE_SUCCESS = "RESET_PAYRATE_SUCCESS"

export const GET_EMPLOYMENT_TYPES = "GET_EMPLOYMENT_TYPES"
export const GET_EMPLOYMENT_TYPES_SUCCESS = "GET_EMPLOYMENT_TYPES_SUCCESS"
export const GET_EMPLOYMENT_TYPES_FAIL = "GET_EMPLOYMENT_TYPES_FAIL"

export const GET_CLASSIFICATION_TYPES = "GET_CLASSIFICATION_TYPES"
export const GET_CLASSIFICATION_TYPES_SUCCESS =
  "GET_CLASSIFICATION_TYPES_SUCCESS"
export const GET_CLASSIFICATION_TYPES_FAIL = "GET_CLASSIFICATION_TYPES_FAIL"

/*Get User Availability */
export const GET_USER_AVAILABILITY = "GET_USER_AVAILABILITY"
export const GET_USER_AVAILABILITY_SUCCESS = "GET_USER_AVAILABILITY_SUCCESS"
export const GET_USER_AVAILABILITY_FAIL = "GET_USER_AVAILABILITY_FAIL"

/*Add User Availability */
export const ADD_USER_AVAILABILITY = "ADD_USER_AVAILABILITY"
export const ADD_USER_AVAILABILITY_SUCCESS = "ADD_USER_AVAILABILITY_SUCCESS"
export const ADD_USER_AVAILABILITY_FAIL = "ADD_USER_AVAILABILITY_FAIL"

/*Add User Profile */
export const ADD_USER_PROFILE = "ADD_USER_PROFILE"
export const ADD_USER_PROFILE_SUCCESS = "ADD_USER_PROFILE_SUCCESS"
export const ADD_USER_PROFILE_FAIL = "ADD_USER_PROFILE_FAIL"

/*Get User Profile */
export const GET_USER_PROFILE = "GET_USER_PROFILE"
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS"
export const GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL"

export const GET_HOUR_TYPES = "GET_HOUR_TYPES"
export const GET_HOUR_TYPES_SUCCESS = "GET_HOUR_TYPES_SUCCESS"
export const GET_HOUR_TYPES_FAIL = "GET_HOUR_TYPES_FAIL"

export const GET_GENDERS = "GET_GENDERS"
export const GET_GENDERS_SUCCESS = "GET_GENDERS_SUCCESS"
export const GET_GENDERS_FAIL = "GET_GENDERS_FAIL"
/*Get USER Profile */
export const GET_PROFILE = "GET_PROFILE"
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL"

export const UPDATE_IMPERSONATE_USER = "UPDATE_IMPERSONATE_USER"
export const UPDATE_IMPERSONATE_USER_SUCCESS = "UPDATE_IMPERSONATE_USER_SUCCESS"
export const UPDATE_IMPERSONATE_USER_FAIL = "UPDATE_IMPERSONATE_USER_FAIL"

export const DELETE_IMPERSONATE_USER = "DELETE_IMPERSONATE_USER"
export const DELETE_IMPERSONATE_USER_SUCCESS = "DELETE_IMPERSONATE_USER_SUCCESS"
export const DELETE_IMPERSONATE_USER_FAIL = "DELETE_IMPERSONATE_USER_FAIL"

export const RESET_USER_PASSWORD = "RESET_USER_PASSWORD"
export const RESET_USER_PASSWORD_SUCCESS = "RESET_USER_PASSWORD_SUCCESS"
export const RESET_USER_PASSWORD_FAIL = "RESET_USER_PASSWORD_FAIL"
